import { useMutation } from '@tanstack/react-query';
import { SKIP_UNAUTH_HEADER } from '@sentinel/api-client';
import { useApi } from '../../lib/api';

export type ConsumeOutcome =
  | { kind: 'success' }
  | { kind: 'mfa_required' }
  | { kind: 'mfa_enrollment_required' };

export function useConsumeMagicLink() {
  const api = useApi();
  return useMutation({
    mutationFn: async (token: string): Promise<ConsumeOutcome> => {
      const { data, error, response } = (await api.GET('/auth/magic-link/verify' as never, {
        params: { query: { token } },
        headers: { Accept: '*/*', [SKIP_UNAUTH_HEADER]: '1' },
      } as never)) as { data?: unknown; error?: unknown; response: Response };

      if (
        response?.status === 403 &&
        (error as { error?: string } | null)?.error === 'mfa_enrollment_required'
      ) {
        return { kind: 'mfa_enrollment_required' };
      }
      if (error) {
        const err = new Error('consume_magic_link_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
      if ((data as { mfa_required?: boolean } | null)?.mfa_required === true) {
        return { kind: 'mfa_required' };
      }
      return { kind: 'success' };
    },
  });
}
